import { Observable } from 'rxjs';
import {
  AddCompanyRequestModel,
  AddCompanyResponseModel,
  CompanyEngagementsModel,
  CompanyLookupResponseModel,
  CompanySearchResponseModel,
  UpdateCompanyRequestModel,
  UpdateCompanyResponseModel,
} from '../../models/company.model';
import {
  COMPANY_ENGAGEMENTS,
  COMPANY,
  COMPANY_SEARCH,
  COMPANY_LOOKUP,
  UPDATE_COMPANY,
} from '../../app.consts';
import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class CompanyApiService extends BaseApiService {
  constructor(private http: HttpClient, protected auth: AuthService) {
    super(auth);
  }

  addCompany(
    body: AddCompanyRequestModel
  ): Observable<AddCompanyResponseModel> {
    return this.http.post<AddCompanyResponseModel>(
      `${this.apiUrl}${COMPANY}`,
      body,
      this.authHeader
    );
  }

  companyEngagements(
    personalNumber: string
  ): Observable<CompanyEngagementsModel[]> {
    return this.http.get<CompanyEngagementsModel[]>(
      `${this.apiUrl}${COMPANY_ENGAGEMENTS}${personalNumber}`
    );
  }

  companySearch(value: string): Observable<CompanySearchResponseModel[]> {
    return this.http.get<CompanySearchResponseModel[]>(
      `${this.apiUrl}${COMPANY_SEARCH}/?freetext=${value.trim()}`
    );
  }

  companyLookup(search: string): Observable<CompanyLookupResponseModel> {
    return this.http.get<CompanyLookupResponseModel>(
      `${this.apiUrl}${COMPANY_LOOKUP}/${search}`
    );
  }

  updateCompany(body: UpdateCompanyRequestModel) {
    return this.http.put<UpdateCompanyResponseModel>(
      `${this.apiUrl}${UPDATE_COMPANY}/${body.id}`,
      body,
      this.authHeader
    );
  }
}
